<script setup lang="ts">
import type { PetType } from '@/types/pet'
import { computed } from 'vue'
import { useUserStore } from '@/stores/modules/user'
import PetInfo from './PetInfo.vue'

const userStore = useUserStore()
const props = defineProps<{ petInfo: PetType }>()
const emits = defineEmits(['close'])

const fightPetInfo = computed(() => {
  return userStore.petList.find((item) => item.id === userStore.fightPetId)
})
</script>

<template>
  <div class="pet-comparsion">
    <div class="module petped">
      <h5>已出战</h5>
      <template v-if="fightPetInfo">
        <PetInfo :pet-info="fightPetInfo" :showLock="false" :is-in-items="false" :is-in-comparison="true" @close-compare="emits('close')" />
      </template>
      <template v-else>
        <p style="text-align: center">(未设置)</p>
      </template>
    </div>
    <div class="module in-items">
      <h5>已选中</h5>
      <PetInfo :pet-info="petInfo" :showLock="false" :is-in-items="true" :is-in-comparison="true" @close-compare="emits('close')" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.pet-comparsion {
  display: flex;
  justify-content: space-between;
  .module {
    width: calc(50% - 5px);
    border: 2px var(--fontColor) solid;
    border-radius: 5px;
    padding: 10px;
    display: flex;
    flex-flow: column nowrap;
    min-height: 320px;
  }
}
</style>
